<template lang="slm">
  .section.album :anchor='album.hash'
    .bg :style='"background-image:url(/api/file/" + album.coverId + ");background-position-y:" + bgY + "%"'
    .container.d-flex.w-100
      .info
        h2.mb-0 {{ album.title }}
        .d-flex.mt-2
          span {{ album.artist }}
          .dot
          span {{ album.year }}
        .cover.d-block.d-lg-none
          .img :style='"background-image:url(/api/file/" + album.coverId + ")"'
        .row.mt-2 v-show='album.serviceLinks.length'
          .col-6.col-sm-3 v-for='serviceLink in album.serviceLinks'
            a.service-link :href='serviceLink.link' target='_blank' rel='noopener noreferrer'
              img :src='"~img/albums_services/" + serviceLink.service + ".png"' alt=''
        .songs.mt-3
          table.table
            tbody
              music-table-row :song='song' :artist='album.artist' :index='index' v-for='song, index in album.songs' :key='index' @audioEnded='playNextAudio(index)' ref='musicTableRow'
      .cover.d-none.d-lg-block
        .img :style='"background-image:url(/api/file/" + album.coverId + ")"'
</template>

<style lang="stylus" scoped>
song_item_height = 62px

.album
  height 600px
  @media (max-width: 991.98px)
    height auto
    padding-top 24px
    padding-bottom 24px
  display flex
  flex-direction column
  justify-content center
  .bg
    position absolute
    top -10%
    left -10%
    width 120%
    height 120%
    background-position center center
    background-repeat no-repeat
    background-size cover
    filter blur(25px) brightness(50%)
    z-index -1
  .info
    flex-grow 1
    text-align left
    display flex
    flex-direction column
    align-self flex-start
    font-size 24px
    font-weight 300
    @media (min-width: 992px)
      padding-right 32px
    @media (max-width: 575.98px)
      font-size 16px
    h2
      font-size 36px
    .dot
      margin-left 10px
      margin-right 10px
      background-color white
      display block
      width 10px
      height 10px
      border-radius 50%
    .songs
      overflow-y auto
      max-height song_item_height * 5
      @media (max-width: 991.98px)
        max-height none
      table
        margin-bottom 0
      tr
        height song_item_height
  .service-link
    display block
    min-width 120px
    min-height 45px
    margin-right 8px
    margin-bottom 8px
    text-align center
    padding 6px
    border-radius 4px
    border 1px solid gray
    background-color rgba(1, 1, 1, 0.2)
    &:hover
      background-color rgba(1, 1, 1, 0.4)
    img
      max-width 100%
      max-height 100%
  .cover
    align-self center
    position relative
    width 100%
    max-width 50vh // чтобы не быть выше чем 50% экрана. высота автоматически равна ширине
    box-shadow 7px 10px 20px -10px dark-color
    @media (min-width: 992px)
      min-width 445px
      width 445px
      max-width none
      height 445px
    &:before
      padding-top 100%
      display block
      content ''
      width 100%
    .img
      background-repeat no-repeat
      background-size cover
      min-height 100%
      position absolute
      top 0
      width 100%
</style>

<script>
import MusicTableRow from '@/components/MusicTableRow';

export default {
  name: 'MusicAlbumSection',
  components: { MusicTableRow },
  props: {
    album: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bgY: 50,
    };
  },
  methods: {
    playNextAudio(currentIndex) {
      if (currentIndex >= this.album.songs.length - 1) {
        this.$root.hideAudioPlayer();
        return;
      }
      const nextIndex = currentIndex + 1;
      this.$refs.musicTableRow[nextIndex].playIfNotPlaying();
    },
  //   updateBgY() {
  //     const value = (window.pageYOffset - this.$el.offsetTop + window.innerHeight) / (this.$el.offsetHeight + window.innerHeight);
  //     this.bgY = value * 100;
  //   },
  },
  // mounted() {
  //   document.addEventListener('scroll', () => {
  //     this.updateBgY();
  //   });
  //   this.updateBgY();
  // },
};
</script>
